export default function ContractsTab() {
  return <div>contract tab</div>;
}
